import { useMemo } from 'react';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import axios from '../../external-libs/axios';
import reducers from './reducers';

let store;

function initStore(initialState) {
  const { headers } = initialState || {};

  const axiosInstance = axios.create({
    headers,
  });

  return createStore(
    reducers,
    initialState,
    applyMiddleware(thunk.withExtraArgument(axiosInstance)),
  );
}

const initializeStore = (preloadedState) => {
  let _store = store ?? initStore(preloadedState);

  if (preloadedState && store) {
    _store = initStore({
      ...store.getState(),
      ...preloadedState,
    });
    store = undefined;
  }

  if (typeof window === 'undefined') return _store;

  if (!store) store = _store;

  return _store;
};

/**
 * Create the store for the current application (support SSR)
 * @param {object} initialState
 * @returns store
 */
export function useStore(initialState) {
  return useMemo(() => initializeStore(initialState), [initialState]);
}
